/**
 * Action cell
 */
import React from 'react';

import { Row } from 'react-table';

import { Action, ActionMenu } from '~shared/components/ActionMenu/ActionMenu';
import { IconEllipsis } from '~shared/components/icons/standard';

interface ActionCellProps {
  row: Row;
  actions: Action<Row>[];
  dataAttr?: string;
}
export const ActionCell = ({ row, actions, dataAttr }: ActionCellProps) => {
  return (
    <div className={'td-outskirts'}>
      <ActionMenu data={[row.original]} actions={actions} mode={'click'}>
        <div
          className={
            'actions hocus:bg-cyan-50 flex items-center justify-center w-12 h-12 p-0 m-0 border-0 rounded-2 appearance-none outline-none transition ease-in-out duration-150 cursor-pointer text-cyan-600 hover:text-cyan-700 focus:text-cyan-700 hover:bg-cyan-50 focus:bg-cyan-50 bg-transparent'
          }
          data-actions={dataAttr}
        >
          <IconEllipsis />
        </div>
      </ActionMenu>
    </div>
  );
};
